var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTagsCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#CEFBE0",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_629_2080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.875 16.9375V28.3125L21 25.0625L16.125 28.3125V16.9375C16.125 16.0755 16.4674 15.2489 17.0769 14.6394C17.6864 14.0299 18.513 13.6875 19.375 13.6875H22.625C23.487 13.6875 24.3136 14.0299 24.9231 14.6394C25.5326 15.2489 25.875 16.0755 25.875 16.9375Z",
    stroke: "#00A68B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_2080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 19.5,
    fill: "white",
    transform: "translate(11.25 11.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTagsCircled);
export default __webpack_public_path__ + "static/media/greenTagsCircled.13146083.svg";
export { ForwardRef as ReactComponent };